import {
    GENERICFORM_SUBMIT,
    GENERICFORM_SUCCESS,
    GENERICFORM_ERROR
} from '../constants';

const defaultState = {};

export const genericForm = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case GENERICFORM_SUBMIT:
            return {
                ...state,
                [payload.formKey]: { submitting: true, errors: {}, success: false }
            };
        case GENERICFORM_SUCCESS:
            return {
                ...state,
                [payload.formKey]: { submitting: false, errors: {}, success: true }
            };
        case GENERICFORM_ERROR:
            return {
                ...state,
                [payload.formKey]: { submitting: false, errors: payload.errors, success: false }
            };
        default:
            return state;
    }
};
